export default __webpack_public_path__ + "static/media/service.4876b3be.jpg";